import { render, staticRenderFns } from "./v_Welcome.vue?vue&type=template&id=4b2e82fb&scoped=true&"
import script from "./v_Welcome.vue?vue&type=script&lang=js&"
export * from "./v_Welcome.vue?vue&type=script&lang=js&"
import style0 from "./v_Welcome.vue?vue&type=style&index=0&id=4b2e82fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e82fb",
  null
  
)

export default component.exports